import { validateEmail, validatePhone, applyPhoneInputMask } from "../utils/helpers";

export default (element) => {
  const emailForm = element.querySelector('[data-email-form]');
  const emailFormInput = element.querySelector('[data-email-form-input]');
  const emailFormInputBody = element.querySelector('[data-email-form-body]');
  const emailFormInputSuccess = element.querySelector('[data-email-form-success]');
  const emailErrorMessage = element.querySelector('[data-newsletter-error-message]');
  const phoneForm = element.querySelector('[data-phone-form]');
  const phoneFormInput = element.querySelector('[data-phone-form-input]');
  const phoneErrorMessage = element.querySelector('[data-phone-error-message]');
  const phoneSuccessMessage = element.querySelector('[data-phone-success-message]');
  const localizationForm = element.querySelector('[data-localization-form]');
  const { klaviyoApiKey, klaviyoEmailListId, klaviyoSMSListId } = JSON.parse(document.querySelector('[data-technical]').textContent);

  const removeEmailErrorState = () => {
    emailErrorMessage.classList.add('hidden');
  };

  const validateEmailForm = (inputValue) => {
    const formIsValid = validateEmail(inputValue);
    if (!formIsValid) {
      emailErrorMessage.classList.remove('hidden');
      emailFormInput.addEventListener('keydown', removeEmailErrorState);
    } else {
      emailErrorMessage.classList.add('hidden');
    };
    return formIsValid;
  };

  const initNewsletterEmailForm = () => {
    if (!emailForm) return;

    emailForm.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      emailErrorMessage.classList.add('hidden');

      if (validateEmailForm(emailFormInput.value)) {
        if (!klaviyoEmailListId || klaviyoEmailListId === '') {
          /* eslint-disable-next-line no-console */
          console.warn('Klaviyo Email List ID is not set');
          return;
        };

        const options = {
          method: 'POST',
          headers: {revision: '2023-01-24', 'content-type': 'application/json'},
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                list_id: klaviyoEmailListId,
                custom_source: 'Footer email subscription form',
                email: emailFormInput.value
              }
            }
          })
        };
        
        // eslint-disable-next-line max-len
        fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${klaviyoApiKey}`, options)
          .then(response => {
            if (!response.ok) {
              emailErrorMessage.classList.remove('hidden');
            } else {
              emailFormInput.removeEventListener('keydown', removeEmailErrorState);
              emailFormInputBody.classList.add('hidden');
              emailFormInputSuccess.classList.remove('hidden');
            };
          })
          .catch(err => {
            emailErrorMessage.innerText = err.message;
            emailErrorMessage.classList.remove('hidden');
          });
      };
    });

    if (emailFormInput) {
      emailFormInput.addEventListener('keyup', () => {
        if (emailForm.classList.contains('invalid')) {
          validateEmailForm(emailFormInput.value);
        };
      });
    };
  };

  const removePhoneErrorState = () => {
    phoneErrorMessage.classList.add('hidden');
  };

  const initSmsSignupForm = () => {
    if (!phoneForm) return;

    phoneFormInput?.addEventListener('input', (e) => {
      if (
        e.inputType !== 'deleteContentBackward'
        && e.inputType !== 'deleteContentForward'
      ) {
        applyPhoneInputMask(e);
      }
    });

    phoneFormInput?.addEventListener('input', (e) => {
      // prevent user from deleting the +1
      if (e.inputType === 'deleteContentBackward' && e.target.value.length <= 2) {
          e.target.value = '+1';
      }
    });

    phoneForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const inputValue = phoneFormInput.value.replace(/\D/g, '');
      const isValid = validatePhone(inputValue);

      if (!isValid) {
        phoneErrorMessage.classList.remove('hidden');
        phoneFormInput.addEventListener('keydown', removePhoneErrorState);
        return;
      };

      if (!klaviyoSMSListId || klaviyoSMSListId === '') {
        /* eslint-disable-next-line no-console */
        console.warn('Klaviyo SMS List ID is not set');
        return;
      };

      const options = {
        method: 'POST',
        headers: {revision: '2023-01-24', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: klaviyoSMSListId,
              custom_source: 'Footer SMS form',
              phone_number: '+'.concat(inputValue)
            }
          }
        })
      };

      // eslint-disable-next-line max-len
      fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${klaviyoApiKey}`, options)
        .then(response => {
          if (!response.ok) {
            phoneErrorMessage.classList.remove('hidden');
          } else {
            phoneForm.classList.add('hidden');
            phoneErrorMessage.classList.add('hidden');
            phoneSuccessMessage.classList.remove('hidden');
            phoneFormInput.removeEventListener(
              'keydown',
              removePhoneErrorState,
            );
            phoneFormInput.removeEventListener('input', (e) => applyPhoneInputMask(e));
          };
        })
        .catch(err => {
          phoneErrorMessage.innerText = err.message;
          phoneErrorMessage.classList.remove('hidden');
        });
    });
  };

  const initLocalizationForm = () => {
    if (!localizationForm) return;

    const countries = element.querySelectorAll('[data-country]');
    const countryInput = element.querySelector('[name="country_code"]');

    countries.forEach(country => {
      country.addEventListener('click', e => {
        e.preventDefault();
        const selectedCountryCode = country.getAttribute('data-country');
        countryInput.value = selectedCountryCode;
        localizationForm.submit();
      });
    });
  }

  const init = () => {
    initNewsletterEmailForm();
    initSmsSignupForm();
    initLocalizationForm();
  }

  init();
};
